
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Calendar as CalendarIcon, Filter } from "lucide-react";
import MonthlyCalendarView from "@/components/admin/MonthlyCalendarView";
import WeeklyCalendarView from "@/components/admin/WeeklyCalendarView";

const ExamCalendar = () => {
  const [activeView, setActiveView] = useState("month"); // Changed default to month
  const [scheduleFilter, setScheduleFilter] = useState("all");

  return (
    <div className="h-full flex flex-col space-y-4">
      <div className="flex justify-between items-center flex-shrink-0">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <CalendarIcon className="h-6 w-6 text-primary" />
          Exam Schedule Calendar
        </h1>
        
        <div className="flex items-center gap-2">
          <Filter className="h-4 w-4 text-gray-500" />
          <Select value={scheduleFilter} onValueChange={setScheduleFilter}>
            <SelectTrigger className="w-48">
              <SelectValue placeholder="Filter schedules" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Schedules</SelectItem>
              <SelectItem value="my">My Schedules</SelectItem>
              <SelectItem value="company">Company Schedules</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="flex-1 min-h-0">
        <Tabs value={activeView} onValueChange={setActiveView} className="h-full flex flex-col">
          <TabsList className="grid w-full max-w-md grid-cols-2 flex-shrink-0">
            <TabsTrigger value="week">Weekly View</TabsTrigger>
            <TabsTrigger value="month">Monthly View</TabsTrigger>
          </TabsList>
          
          <TabsContent value="week" className="flex-1 min-h-0">
            <WeeklyCalendarView scheduleFilter={scheduleFilter} />
          </TabsContent>
          
          <TabsContent value="month" className="flex-1 min-h-0">
            <MonthlyCalendarView scheduleFilter={scheduleFilter} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default ExamCalendar;
